import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { FiInfo, FiX, FiShoppingBag } from "react-icons/fi";
export default function ModuleHeader({
  userName,
  subtitle,
  title,
  description,
  backgroundImage,
  onExpandedChange,
  showToggle = true,
  autoHeight = false,
  fontFamily = "font-poppins", // Default: Spicy Rice, alternatif: font-poppins
}) {
  const { id, moduleId } = useParams();
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isInfoOpen, setIsInfoOpen] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
    if (onExpandedChange) {
      onExpandedChange(!isExpanded);
    }
  };
  return (
    <div
      className={`relative w-full ${autoHeight ? 'h-auto' : 'h-64'} bg-gradient-to-br from-[#379cab] to-[#2a8a96] bg-cover bg-center bg-no-repeat rounded-b-3xl overflow-hidden transition-all duration-300`}
      style={backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : {}}
    >
      {/* Show overlays only if there is a background image to keep identity color pure otherwise */}
      {backgroundImage && (
        <>
          <div className="absolute inset-0 bg-[#379cab] opacity-20"></div>
          <div className="absolute inset-0 bg-black opacity-30"></div>
        </>
      )}

      {/* Content */}
      <div className={`relative z-10 flex flex-col ${autoHeight ? '' : 'h-full'} text-white py-4`}>
        {/* Top Navigation */}
        <div className="flex items-center justify-start text-start mb-4">
          {/* Back Button */}
          <button
            onClick={() => navigate(`/${id}/module-list`)}
            className="p-2 pl-4 pr-2 hover:bg-white/20 rounded-full transition-colors"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <div className="">
            <h2 className={`text-sm font-bold ${fontFamily}`}>{userName}</h2>
            <p className={`text-xs opacity-90 font-normal ${fontFamily}`}>{subtitle}</p>
          </div>
        </div>

        {/* User Info */}

        {/* Main Content */}
        <div className="flex mx-4 flex-row items-center justify-start mt-2">
          <h1 className={`text-md text-start font-bold mb-1 ml-8 ${fontFamily}`}>{title}</h1>
        </div>

        {/* Global Action Buttons in Top-Right */}
        <div className="absolute top-4 right-4 z-40 flex items-center gap-2">
          <button
            onClick={() => navigate(`/${id}/store`)}
            className="p-2.5 bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 rounded-full transition-all active:scale-90 text-white shadow-lg"
          >
            <FiShoppingBag size={18} />
          </button>

          <button
            onClick={() => setIsInfoOpen(true)}
            className="p-2.5 bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 rounded-full transition-all active:scale-90 text-white shadow-lg"
          >
            <FiInfo size={18} />
          </button>
        </div>

        {/* Info Popup */}
        <AnimatePresence>
          {isInfoOpen && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/40 backdrop-blur-sm"
              onClick={() => setIsInfoOpen(false)}
            >
              <motion.div
                initial={{ scale: 0.9, opacity: 0, y: 20 }}
                animate={{ scale: 1, opacity: 1, y: 0 }}
                exit={{ scale: 0.9, opacity: 0, y: 20 }}
                className="bg-white rounded-[2rem] p-8 w-full max-w-[320px] shadow-2xl relative overflow-hidden"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Decorative Background */}
                <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#3DA7B5]/10 rounded-full blur-3xl" />
                <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-[#5ABCC8]/10 rounded-full blur-3xl" />

                <div className="relative z-10 space-y-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-2xl bg-[#3DA7B5]/10 flex items-center justify-center text-[#3DA7B5]">
                        <FiInfo size={20} />
                      </div>
                      <h3 className="font-black text-gray-900 text-lg">{title}</h3>
                    </div>
                    <button
                      onClick={() => setIsInfoOpen(false)}
                      className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                    >
                      <FiX size={20} className="text-gray-400" />
                    </button>
                  </div>

                  <div className="space-y-4">
                    <p className="text-gray-600 text-sm leading-relaxed font-medium">
                      {description || "Bu modül hakkında henüz bir açıklama bulunmuyor."}
                    </p>

                    <button
                      onClick={() => setIsInfoOpen(false)}
                      className="w-full py-3 bg-[#3DA7B5] text-white rounded-2xl font-black text-sm shadow-xl shadow-[#3DA7B5]/20 hover:bg-[#2a8a96] transition-colors active:scale-95"
                    >
                      Anladım
                    </button>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
}
